import React from 'react';
import { OreIconButton, SvgChevronDown, SvgChevronUp } from '@edenredespana/oreneta';
import { MultiWebClientMerchantModel } from '@/User/domain';
import edificioPng from '../../assets/edificio.png';
import { DROPDOWN_STYLES } from '../constants/masterStyles';

interface MerchantItemProps {
  arrow?: 'up' | 'down';
  merchant: MultiWebClientMerchantModel;
  isHovered: boolean;
  isFirst: boolean;
  isLast: boolean;
  hasSubItems: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
  onToggleExpand?: () => void;
}

/**
 * Componente atómico para mostrar un item de comercio principal en la lista.
 * Incluye icono, nombre, CIF y código del comercio.
 * 
 * @param merchant - Datos del comercio a mostrar
 * @param isHovered - Indica si el item está siendo hovereado
 * @param isFirst - Indica si es el primer item de la lista
 * @param isLast - Indica si es el último item de la lista
 * @param hasSubItems - Indica si el comercio tiene sub-items
 * @param onMouseEnter - Función para manejar el hover
 * @param onMouseLeave - Función para manejar cuando sale del hover
 * @param onClick - Función para manejar el clic
 */
export const MasterMerchantItem: React.FC<MerchantItemProps> = ({
  merchant,
  isHovered,
  isFirst,
  isLast,
  hasSubItems,
  onMouseEnter,
  onMouseLeave,
  onClick,
  onToggleExpand,
  arrow,
}) => {
  return (
    <div
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        ...DROPDOWN_STYLES.merchantItemBase,
        background: isHovered ? '#F1F5F9' : 'transparent',
        borderTop: !isFirst ? '1.5px solid #e0e0e0' : 'none',
        borderBottom: isLast && !hasSubItems && !merchant.isMasterGroup ? 'none' : '1.5px solid #e0e0e0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      {!merchant.isMasterGroup ? (
        <span style={DROPDOWN_STYLES.merchantItemIcon}>
          <img src={edificioPng} alt="edificio" width={22} height={22} />
        </span>): null}
      <span style={DROPDOWN_STYLES.merchantItemContent}>
        <span style={DROPDOWN_STYLES.merchantItemName}>
          {merchant.name}
        </span>
        {merchant.isMasterGroup ? null :(
          <span style={DROPDOWN_STYLES.merchantItemDetails}>
            {merchant.cif} - {merchant.code}
          </span>)}
      </span>
      {arrow && (
        <OreIconButton
          icon={arrow === 'up' ? <SvgChevronUp /> : <SvgChevronDown />}
          onClick={(e) => {
            e.stopPropagation();
            onToggleExpand?.();
          }}
          aria-label={arrow === 'up' ? 'Contraer subcomercios' : 'Expandir subcomercios'}
          style={{ marginLeft: 'auto' }}
        />
      )}
    </div>
  );
};
